import {AutocompleteComponent, IAutocompleteOptions} from '../classes/autocomplete';

export function initGlobalSearchAutocomplete() {
    var inputs = document.querySelectorAll("[data-search-autocomplete-input]");
    [].forEach.call(inputs, (input) => {
        const autocompleteId = input.id;
        const autocompleteContainer = document.querySelector(`[data-search-autocomplete-results="${autocompleteId}"]`) as HTMLElement;

        new SearchAutocomplete(input, autocompleteContainer);
    });
}

export class SearchAutocomplete {
    readonly AutocompleteSize = 3;
    readonly ActiveClass = 'active';
    readonly AutocompleteItemAttribute = 'data-autocomplete-item';

    _input: HTMLInputElement;
    _submitBtn: HTMLButtonElement;
    //_xBtn: HTMLButtonElement;
    _autocompleteContainer: HTMLElement;
    _lastSearchedTerm: string;
    uniqueId: string;

    constructor(input: HTMLInputElement, autocompleteContainer: HTMLElement) {
        this._input = input;
        this.uniqueId = input.id;
        this._submitBtn = document.querySelector(`[data-search-autocomplete-submit="${this.uniqueId}"]`) as HTMLButtonElement;
        //this._xBtn = document.querySelector(`[data-search-autocomplete-clear="${this.uniqueId}"]`) as HTMLButtonElement;
        this._autocompleteContainer = autocompleteContainer;
        this._lastSearchedTerm = '';
        this.initialize();
    }

    initialize = () => {
        const panel = document.querySelector(`[data-search-autocomplete-panel="${this.uniqueId}"]`) as HTMLElement;
        const form = document.querySelector(`[data-search-autocomplete-form="${this.uniqueId}"]`) as HTMLFormElement;
        const autocompleteOptions: IAutocompleteOptions = {
            input: this._input,
            panelContainer: panel,
            resultsContainer: this._autocompleteContainer,
            blockContainer: form.parentElement,
            keys: ["query"],
            autocompleteSelector: `#${this.uniqueId}`,
            autocompleteResultsSelector: `[data-search-autocomplete-results="${this.uniqueId}"]`,
            resultFormat: (data, source) => {
                source.innerHTML = this.formatResult(data["match"], data["value"]["query"]);
                source.setAttribute('class', 'autocomplete-result');
            },
            sortFunction: (a, b) => {
                return a["value"]["query"].localeCompare(b["value"]["query"]);
            },
            dataSrc: async () => {
                this._lastSearchedTerm = this._input.value;
                if (this._lastSearchedTerm) {
                    const source = await fetch(this.getAutocompleteUrl(this._lastSearchedTerm));
                    const data = await source.json();
                    return data["hits"];
                }
            },
            cache: false,
            clickCallback: (target) => {
                if (target.hasAttribute('data-query')) {
                    this._input.value = target.getAttribute('data-query');
                    form.submit();
                }
            },
            //closeButton: this._xBtn,
            uniqueId: this.uniqueId,
            noResultsMsg: '<button type="submit" class="un-button hyperlink autocomplete-result-link titling">Search "<strong>{{term}}</strong>"</button>'
        }
        new AutocompleteComponent(autocompleteOptions);

        form.addEventListener('submit', (e) => {
            if (this._input.value == '') {
                e.preventDefault();
            }
        });

        this._input.addEventListener('keyup', this.checkSubmit.bind(this));
        this._input.addEventListener('change', this.checkSubmit.bind(this));
    }

    checkSubmit() {
        if (this._input.value == '') {
            this._submitBtn.setAttribute('disabled', '');
            //this._xBtn.setAttribute('aria-hidden', 'true');
        } else {
            this._submitBtn.removeAttribute('disabled');
            //this._xBtn.setAttribute('aria-hidden', 'false');
        }
    }

    getAutocompleteUrl(query: string) {
        return `/api/v1/search/autocomplete/${query}/${this.AutocompleteSize}`;
    }

    formatResult(match: string, query: string) {
        return `<button type="button" data-query="${query}" class="un-button hyperlink autocomplete-result-link titling" tabindex="-1">${match}</button>`;
    }
}